module.exports = __webpack_public_path__ + "img/icon-certified-ribbon.3970dd66.svg";